(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('ModelHandlerController', ModelHandlerController);
    
    ModelHandlerController.$inject = ['$uibModal','$scope','$uibModalInstance','$rootScope'];
    
    function ModelHandlerController($uibModal,$scope,$uibModalInstance,$rootScope){
    	
    	$scope.modulePage="Registration";
    	//$scope.data=$rootScope.nikhil;
    	$scope.cancelModal = function(){
    		 $uibModalInstance.dismiss('close');
    		 }
    }

})();